module.exports = __webpack_public_path__ + "img/co-landing-small.58c7bfc.jpg";